import React from 'react';

export default class PageLoadBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <div role="alert" className="m-8 rounded-2xl border border-slate-200 bg-white p-6">
      <h1 className="text-lg font-semibold">Unable to load this page</h1>
      <p className="mt-2 text-sm text-slate-600">Please reload to try again.</p>
      <button className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white" onClick={() => window.location.reload()}>Reload page</button>
    </div>;
    return this.props.children;
  }
}
